import { memo } from 'react'
import classNames from 'classnames'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import styles from './LoginFooter.module.scss'
import { useDeviceWidth } from '../../../../common/hooks'
import configuration from '../../../../configuration'
import { LoginFooterProps } from '../../Login.d'

const setTextSizeByWindowWidth = (width: number) => {
  if (width >= 1200) {
    return 'default'
  } else if (width >= 576) {
    return 'small'
  }
  return 'xsmall'
}

const LoginFooter = ({ className = '', ...props }: LoginFooterProps) => {
  const deviceWidth = useDeviceWidth()

  return (
    <div className={classNames(styles.content, className)} {...props}>
      <Paragraph
        className={styles.text}
        size={setTextSizeByWindowWidth(deviceWidth)}
        weight="book"
      >
        Need help? Contact{' '}
        <a
          className={styles.link}
          href={configuration.contactUsUrl}
          target="_blank"
          rel="noreferrer"
        >
          Customer Support
        </a>
        .
      </Paragraph>
    </div>
  )
}

export default memo(LoginFooter)
